// Paid Users Report Constants

export const PAID_USERS_REPORT_REQUEST = "PAID_USERS_REPORT_REQUEST";
export const PAID_USERS_REPORT_SUCCESS = "PAID_USERS_REPORT_SUCCESS";
export const PAID_USERS_REPORT_FAIL = "PAID_USERS_REPORT_FAIL";

export const PAID_USERS_LIST_REQUEST = "PAID_USERS_LIST_REQUEST";
export const PAID_USERS_LIST_SUCCESS = "PAID_USERS_LIST_SUCCESS";
export const PAID_USERS_LIST_FAIL = "PAID_USERS_LIST_FAIL";

export const CLEAR_REPORT_ERRORS = "CLEAR_REPORT_ERRORS";

// Revenue, Conversion, Retention report constants
export const REVENUE_REPORT_REQUEST = "REVENUE_REPORT_REQUEST";
export const REVENUE_REPORT_SUCCESS = "REVENUE_REPORT_SUCCESS";
export const REVENUE_REPORT_FAIL = "REVENUE_REPORT_FAIL";

export const CONVERSION_REPORT_REQUEST = "CONVERSION_REPORT_REQUEST";
export const CONVERSION_REPORT_SUCCESS = "CONVERSION_REPORT_SUCCESS";
export const CONVERSION_REPORT_FAIL = "CONVERSION_REPORT_FAIL";

export const RETENTION_REPORT_REQUEST = "RETENTION_REPORT_REQUEST";
export const RETENTION_REPORT_SUCCESS = "RETENTION_REPORT_SUCCESS";
export const RETENTION_REPORT_FAIL = "RETENTION_REPORT_FAIL";
